(function ($) {

    ///////////////      INITIALIZATION     //////////////////////
    this.init = function () {

        configureMobileKeyNav();

        // attach event handlers
        $("#mobile-nav a.level1-item-link-a").keydown(handleKeyboard);
        $("#mobile-nav a.level2-item-link-a").keydown(handleKeyboard);
        $(".globalheader-content-rightmobile-menu").on("click", toggleMobileNav);

        $(window).on("resize", onResize);

        initMobileNav();
    };
    function onResize() {
        if (window.innerWidth > 991) {
            hideMobileNav();
        }
    }

    function handleKeyboard(event) {

        if (event.which === 37) {
            // left - if this item is open, we close it.
            if (!$(event.currentTarget).parent().parent().hasClass("Open")) {
                if ($(event.currentTarget).parent().find("> .collapse-open").length > 0) {
                    $(event.currentTarget).parent().find("> .collapse-open")[0].click();
                } else if ($(event.currentTarget).parent().find("> .level2-collapse-open").length > 0) {
                    $(event.currentTarget).parent().find("> .level2-collapse-open")[0].click();
                }

            }
            event.preventDefault();

        } else if (event.which === 39) {
            // right - if this item is closed, open it.
            if (!$(event.currentTarget).parent().parent().hasClass("Open")) {
                if ($(event.currentTarget).parent().find("> .collapse-closed").length > 0) {
                    $(event.currentTarget).parent().find("> .collapse-closed")[0].click();
                } else if ($(event.currentTarget).parent().find("> .level2-collapse-closed").length > 0) {
                    $(event.currentTarget).parent().find("> .level2-collapse-closed")[0].click();
                }
            }
            event.preventDefault();

        } else if (event.which === 27) {
            $("#mobile-menu-open")[0].click();
        }
    }

    function configureMobileKeyNav() {
        var $this, $that, $thisLink, $thatLink;

        var $mobileNav = $(".mobile-nav");

        $mobileNav.find(".level1-item").each(function (index) {
            $this = $(this);

            $thisLink = $this.find("a.level1-item-link-a");


            // set up the aria label on level 1 links
            if (index === 0) {
                $thisLink.attr("aria-label", "Top Level Menu Item: " + $thisLink.text() + ". To use nav, press right arrow key to expand submenu items. Press left to close. Use Tab and shift tab to navigate to next and previous items. Press escape to exit nav");
            } else {
                $thisLink.attr("aria-label", "Top Level Menu Item: " + $thisLink.text() + " with " + $this.find(".level2-item").length + " children");
            }

            // hide the + or - if there are no children

            if (!$this.hasClass("has-children")) {
                $this.find(".level1-collapse").remove();
            }

            $this.find(".level2-item").each(function (jindex) {
                $that = $(this);
                $thatLink = $that.find("a.level2-item-link-a");

                $thatLink.attr("aria-label", "Second Level Menu Item: " + $thatLink.text() + " with " + $that.find(".level3-item").length + " children");

                if (!$that.hasClass("has-children")) {
                    $this.find(".level2-collapse").remove();
                }

                $that.find(".level3-item").each(function () {
                    $(this).find("a").attr("aria-label", "Third Level Menu Item: " + $(this).find("a").text());
                });
            });
        });
    }

    function initMobileNav() {

        var $parentLevel;

        $('.mobile-nav .has-children>a').click(function (e) {
            e.stopPropagation();
        });

        $('.mobile-nav .level1-item.has-children .level1-collapse').click(function (e) { // Level 1 clicks

            $parentLevel = $(this).parents(".level1-item");

            $parentLevel.siblings('.open').removeClass('open')
                .find('.level2').slideUp(250, 'swing', null)
                .find('.level2-item.has-children.open').removeClass('open')
                .find('.level3').slideUp(250, 'swing', null);
            if (!$parentLevel.hasClass('open')) {
                e.preventDefault();
                $parentLevel.addClass('open').find('> .level2').slideDown(250, 'swing', null);
            } else if ($parentLevel.hasClass('open')) {
                $parentLevel.removeClass('open');
                $parentLevel.find('.level2').slideUp(250, 'swing', null)
                    .find('.level2-item.has-children.open').removeClass('open')
                    .find('.level3').slideUp(250, 'swing', null);
            }
        });
        $('.mobile-nav .level2-item.has-children .level2-collapse').click(function (e) { // Level 2 clicks

            $parentLevel = $(this).parents(".level2-item");

            $parentLevel.siblings('.open').removeClass('open')
                .find('.level3').slideUp(250, 'swing', null);
            if (!$parentLevel.hasClass('open')) {
                e.preventDefault();
                $parentLevel.addClass('open')
                    .find('> .level3')
                    .slideDown(250, 'swing', null);
            } else if ($parentLevel.hasClass("open")) {
                $parentLevel.removeClass("open");
                $parentLevel.find('.level3').slideUp(250, 'swing', null);

            }
        });
    }
    function hideMobileNav() {
        $("#mobile-nav").hide();
        $(".level1-item-link-a").attr("tabindex", "-1");
        $(".globalheader-content-rightmobile-menu").removeClass("open");
    }

    function showMobileNav() {
        $("#mobile-nav").show();
        // set the mobiel nav top level items to be tabbable
        $(".level1-item-link-a").attr("tabindex", "0");
        $(".globalheader-content-rightmobile-menu").addClass("open");
    }

    function toggleMobileNav() {

        if ($("#mobile-nav").css("display") === "none") {
            showMobileNav();
        } else {
            hideMobileNav();
        }
    }

    this.init();

})(jQuery);